import { vsingleton } from '@niknevis/vue-modules'
import RouteBase from '@niknevis/vue-modules/abstracts/RouteBase'

@vsingleton()
export class AdminDepartmentRoute extends RouteBase {
  prefix = 'admin.support.departments.'

  index() {
    return this.ziggyRoute('index')
  }

  store() {
    return this.ziggyRoute('store')
  }

  show(departmentId: number) {
    return this.ziggyRoute('show', departmentId)
  }

  update(departmentId: number) {
    return this.ziggyRoute('update', departmentId)
  }

  destroy(departmentId: number) {
    return this.ziggyRoute('destroy', departmentId)
  }

  search() {
    return this.ziggyRoute('search')
  }
}
